import React from "react";
import { motion } from "framer-motion";

const AlYasminahServices: React.FC<{ content?: any }> = ({ content }) => {
  const services = [
    {
      image: content?.svc_1_image || content?.banner_1 || content?.image || content?.about_image || "/banner/alyasminah_1.jpg",
      title: content?.svc_1_title || "Preventive Maintenance",
      desc: content?.svc_1_desc || "Structured maintenance for all core building systems.",
    },
    {
      image: content?.svc_2_image || content?.banner_2 || content?.image || content?.about_image || "/banner/alyasminah_2.jpg",
      title: content?.svc_2_title || "Hygiene & Safety",
      desc: content?.svc_2_desc || "Rigorous inspection standards for lifting and hygiene systems.",
    },
    {
      image: content?.svc_3_image || content?.banner_3 || content?.image || content?.about_image || "/banner/alyasminah_3.jpg",
      title: content?.svc_3_title || "Strategic Asset Care",
      desc: content?.svc_3_desc || "Meticulous asset inventory and vendor management.",
    },
  ];

  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 font-sans">
      <motion.div
        className="bg-white rounded-3xl shadow-xl p-8 md:p-12 border border-slate-100"
        initial={{ opacity: 0, y: 40 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6 }}
      >
        <h2 className="text-2xl md:text-4xl font-black text-center text-slate-800 tracking-tight mb-12">
          {content?.services_title || "Our Management Services"}
        </h2>
        <div className="grid md:grid-cols-3 gap-8">
          {services.map((svc, i) => (
            <div 
              key={i} 
              className="flex flex-col rounded-2xl bg-slate-50 border border-slate-100 overflow-hidden shadow-sm hover:shadow-md hover:-translate-y-1 transition-all duration-300 group"
            >
              <div className="w-full h-56 overflow-hidden bg-slate-100 relative">
                <img 
                  src={svc.image} 
                  alt={svc.title} 
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" 
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/20 to-transparent opacity-0 group-hover:opacity-100 transition-opacity" />
              </div>
              <div className="p-6 md:p-8 flex flex-col flex-1">
                <h3 className="text-xl font-bold text-slate-800 mb-4 tracking-tight group-hover:text-blue-600 transition-colors">
                  {svc.title}
                </h3>
                <p className="text-slate-600 text-sm leading-relaxed flex-1">
                  {svc.desc}
                </p>
              </div>
            </div>
          ))}
        </div>
      </motion.div>
    </div>
  );
};

export default AlYasminahServices;
